import { render, staticRenderFns } from "./registration-form-view.vue?vue&type=template&id=401c31b7&scoped=true&"
import script from "./registration-form-view.vue?vue&type=script&lang=js&"
export * from "./registration-form-view.vue?vue&type=script&lang=js&"
import style0 from "./registration-form-view.vue?vue&type=style&index=0&id=401c31b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c31b7",
  null
  
)

export default component.exports